document.querySelector('.menu i').onclick = function (e) {
    var nav = document.querySelector('.menu');
    nav.classList.toggle('open');
    e.preventDefault();
}
